export default __webpack_public_path__ + "static/media/indimg8.03c0e59a.webp";